import * as React from 'react';

import * as Axon from '@jlekie/axon';
import * as Wellspring from '@greenheck/wellspring';

import * as Settings from '../contexts/settings';
import * as Services from '../../lib/services';
import { createWellspringServiceClient } from '../../lib/serviceClient';

export const useDiagnosticXM = () => {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Diagnostic.DebugServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Diagnostic.DebugServiceClient, settings.servicesUrl, 'bff.cygnus.diagnostic.debug'));
    }, [ settings ]);

    const test = async () => {
        await serviceClient?.entanglement()
    }

    const resolveMacro = async (entityKey: string, macro: string, qualifier?: string) => {
        if (qualifier)
            return serviceClient?.testMacro(entityKey, macro, qualifier)
        else
            return serviceClient?.testMacro(entityKey, macro)
    }

    return [ test, resolveMacro ] as const;
}